import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';

app.initializers.add('acme/flarum-quote-injector', () => {
  const injectedDiscussions = new Set();

  extend(DiscussionPage.prototype, 'oncreate', function() {
    injectQuoteWidget(this);
  });

  extend(DiscussionPage.prototype, 'onupdate', function() {
    injectQuoteWidget(this);
  });

  function injectQuoteWidget(discussionPage) {
    const discussion = discussionPage.discussion;
    
    if (!discussion) return;

    const discussionId = discussion.id();
    
    if (injectedDiscussions.has(discussionId)) return;

    setTimeout(() => {
      const posts = document.querySelectorAll('.PostStream-item .Post');
      
      if (posts.length < 3) return;

      if (document.getElementById('v8b558a44efd')) return;

      const secondPost = posts[1];
      
      if (!secondPost) return;

      const widgetContainer = document.createElement('div');
      widgetContainer.className = 'Post QuoteInjector-widget';
      widgetContainer.style.cssText = 'margin: 20px 0; padding: 20px; background: #f8f9fa; border-radius: 8px; border-left: 4px solid #238c59;';
      
      const widgetContent = document.createElement('div');
      widgetContent.innerHTML = '<div id="v8b558a44efd"></div>';
      
      widgetContainer.appendChild(widgetContent);

      secondPost.parentNode.insertBefore(widgetContainer, secondPost.nextSibling);

      const script = document.createElement('script');
      script.textContent = `
        vud_partenaire_id = '1170';
        vud_keyword = document.title;
        vud_keyword = encodeURI(vud_keyword);
        vud_box_id = '8b558a44ef';
        var vud_js = document.createElement('script'); 
        vud_js.type = 'text/javascript';
        vud_js.src = '//www.viteundevis.com/marqueblanche/?b='+vud_box_id+'&p='+vud_partenaire_id+'&c='+vud_keyword;
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(vud_js, s);
      `;
      
      widgetContainer.appendChild(script);

      injectedDiscussions.add(discussionId);
    }, 500);
  }
});